const BASE_HELP_URL = 'https://help.overstory.com/en/articles';

export const HELP_ARTICLES = {
  fallInHealth: `${BASE_HELP_URL}/10006672-fall-in-health-risk`,
  encroachmentRisk: `${BASE_HELP_URL}/8703918-encroachment-risk`,
  encroachmentRiskGroups: `${BASE_HELP_URL}/8703918-encroachment-risk#h_fd67da15f9`,
  priorityLevels: `${BASE_HELP_URL}/8570309-priority-levels`,
  priorityLevelsGroups: `${BASE_HELP_URL}/8570309-priority-levels#h_961708375c`,
  wildfireIntelligence: `${BASE_HELP_URL}/15347203-wildfire-intelligence`,
  wildfireIntelligenceFuelHazard: `${BASE_HELP_URL}/15347203-wildfire-intelligence#h_83b17f18d5`,
  redFlagWarnings: `${BASE_HELP_URL}/11785978-jul-2025-red-flag-warnings`,
  projects: `${BASE_HELP_URL}/11587369-jun-2025-projects#h_3e14a93040`,
  scenarios: `${BASE_HELP_URL}/14659754-april-2026-scenarios`,
  criticalTrees: `${BASE_HELP_URL}/11838949-critical-trees`,
} as const;
